import TreatmentGroupBookingView from './TreatmentGroupBookingView';

export default TreatmentGroupBookingView;
